import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
export default function LeftNavLink({
  active,
  text,
  showText,
  Icon,
  homepage,
}) {
  const location = useLocation();

  const [act, setAct] = useState(active);
  const [isHomepage, setIsHomepage] = useState(true);

  useEffect(() => {
    const path = location.pathname.slice(1);
    let home_routes = [
      "overview",
      "salary-details",
      "employment-contract",
      "insurance",
      "benifits",
      "payslips",
    ];
    setIsHomepage(
      (home_routes.indexOf(path) > -1 ||
        location.pathname === "/" ||
        location.pathname === "/agile-portal/") &&
        text === "Home"
    );
  }, [location.pathname, text]);

  useEffect(() => {
    setAct(location.pathname.includes(text.toLowerCase().split(" ").join("-")));
  }, [location.pathname, text]);

  return (
    <NavLink
      to={homepage ? "/" : `/${text?.toLowerCase().split(" ").join("-")}`}
      className={({ isActive }) =>
        `group cursor-pointer py-2 w-full flex items-center space-x-3 border-r-2 ${
          isActive
            ? " text-[#BA004F] border-[#BA004F] "
            : `${
                isHomepage
                  ? "text-[#BA004F] border-[#BA004F]"
                  : " border-transparent text-gray-400 "
              }`
        } ${showText ? "justify-start pl-3" : "justify-center"} `
      }
    >
      <Icon active={act} />
      {showText && <b className="text-xs group-hover:text-[#BA004F]">{text}</b>}
    </NavLink>
  );
}
